(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    const source = document.querySelector('script[data-glossary-map]');
    if (!source) return;

    let articles;
    try {
      articles = JSON.parse(source.textContent);
    } catch (e) {
      return;
    }
    if (!articles || !articles.length) return;

    // Build search terms from each article title. "Oat Oil (Avena Sativa Kernel
    // Oil)" yields both "Oat Oil" and "Avena Sativa Kernel Oil", so an
    // ingredient written either way still matches. Longest first, so
    // "Sweet Almond Oil" wins over a bare "Almond Oil".
    // Labels on the packaging don't always match the glossary title, and some
    // contain typos ("Cymbopogon Martini", "Prunus Almeniaca", "Kernal").
    // These aliases bridge that gap. Longer terms are matched first, so
    // "Citrus Aurantium Dulcis" wins over Neroli's "Citrus aurantium" —
    // without it, sweet orange peel oil links to the wrong article.
    const ALIASES = [
      ['Citrus Aurantium Dulcis', 'sweet-orange-essential-oil-citrus-aurantium-dulcis'],
      ['Citrus Aurantium Amara', 'neroli-essential-oil-citrus-aurantium'],
      ['Cymbopogon Martini', 'palmarosa-essential-oil-cymbopogon-martinii'],
      ['Sodium Neemate', 'neem-oil-azadirachta-indica'],
      ['Calendula Officinalis', 'calendula-oil-calendula-officinalis-extract'],
      ['Olea Europa', 'olive-pomace-oil'],
      ['Theobroma Cacao', 'cocoa-butter'],
      ['Ricinus Communis', 'castor-oil-ricinus-communis-seed-oil'],
      ['Prunus Almeniaca', 'apricot-kernel-oil-prunus-armeniaca'],
      ['Prunus Armeniaca', 'apricot-kernel-oil-prunus-armeniaca'],
      ['Citrus Medica Limonum', 'lemon-essential-oil-citrus-limon'],
      ['Goat Milk Powder', 'goats-milk-caprae-lac'],
      ['Sodium Bicarbonate', 'sodium-bicarbonate'],
      ['Pumice', 'pumice-stone-pumex'],
      ['Avena Sativa Kernal Meal', 'oats-avena-sativa'],
    ];

    const terms = [];
    ALIASES.forEach(function (pair) {
      terms.push({ term: pair[0], url: '/blogs/glossary/' + pair[1] });
    });
    articles.forEach(function (article) {
      const title = (article.title || '').trim();
      if (!title) return;
      const outside = title.replace(/\s*\(.*?\)\s*/g, ' ').trim();
      const inside = (title.match(/\(([^)]+)\)/) || [])[1];
      [outside, inside].forEach(function (term) {
        if (term && term.length > 3) terms.push({ term: term.trim(), url: article.url });
      });
    });
    terms.sort(function (a, b) {
      return b.term.length - a.term.length;
    });

    function escapeRegex(value) {
      return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    const items = document.querySelectorAll('.metafield-rich_text_field li, .product-ingredients li');
    items.forEach(function (item) {
      // Never touch an item that is already linked.
      if (item.querySelector('a')) return;

      for (let i = 0; i < terms.length; i++) {
        const entry = terms[i];
        const pattern = new RegExp('(' + escapeRegex(entry.term) + ')', 'i');
        if (!pattern.test(item.textContent)) continue;

        // Only rewrite plain text nodes, so nested markup survives intact.
        let linked = false;
        Array.prototype.slice.call(item.childNodes).forEach(function (node) {
          if (linked || node.nodeType !== Node.TEXT_NODE) return;
          const match = node.nodeValue.match(pattern);
          if (!match) return;

          const before = node.nodeValue.slice(0, match.index);
          const matched = node.nodeValue.slice(match.index, match.index + match[0].length);
          const after = node.nodeValue.slice(match.index + match[0].length);

          const anchor = document.createElement('a');
          anchor.href = entry.url;
          anchor.textContent = matched;

          const frag = document.createDocumentFragment();
          if (before) frag.appendChild(document.createTextNode(before));
          frag.appendChild(anchor);
          if (after) frag.appendChild(document.createTextNode(after));
          node.parentNode.replaceChild(frag, node);
          linked = true;
        });

        if (linked) break;
      }
    });
  });
})();
